import React from 'react'

import { Box, HrefGamma, Text } from '@factorialco/deprecated-design-system'

import helpCenterUrl, { HelpCenterUrl } from 'modules/core/lib/helpCenterUrl'
import { Colors } from 'modules/core/lib/tokens/colors'

interface Props {
  ledeText: string
  helpCenterKey: HelpCenterUrl
  linkText: string
  color?: Colors
}

const LearnMoreAboutLink: React.FC<Props> = ({ ledeText, helpCenterKey, linkText, color }) => {
  return (
    <Box flexDirection="row" gap={'s4'} inline>
      <Text.Normal size="200" color={color}>
        {ledeText}
      </Text.Normal>
      <HrefGamma href={helpCenterUrl(helpCenterKey)} target="_blank" rel="noopener noreferrer">
        <Text.Normal size="200" underlined color={'viridian1200'}>
          {linkText}
        </Text.Normal>
      </HrefGamma>
    </Box>
  )
}

export default LearnMoreAboutLink
